import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import TopNav from "../TopNav";
import Footer from "../Footer";
import { API_URL } from "../config";

const SalesShift = () => {
  const [accounts, setAccounts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');

  const company_id = localStorage.getItem("company_id");

  const fetchBranches = async () => {
    if (company_id) {
      try {
        const response = await fetch(`${API_URL}/branches/company/${company_id}`);
        const data = await response.json();
        setBranches(data);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const fetchSalesShifts = async () => {
    try {
      const response = await fetch(`${API_URL}/salesshiftgas/co/${company_id}`);
      const data = await response.json();
      setAccounts(data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchBranches();
    fetchSalesShifts();
  }, []);

  // Filter accounts based on the selected branch name
  const filteredAccounts = selectedBranch
    ? accounts.filter(item => item.branch === selectedBranch)
    : accounts;

  return (
    <div>
      <div className="dashboard-main-wrapper">
        <TopNav />
        <SideBar />

        <div className="dashboard-wrapper">
          <div className="container-fluid dashboard-content">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div>
                  <h5 className="header" style={{ fontFamily: "sans-serif" }}>
                    Sales Shifts
                  </h5>
                  <div className="page-breadcrumb">
                    <nav aria-label="breadcrumb"></nav>
                  </div>
                  <div className="form-group">
                    <label htmlFor="branchSelect">Select Branch</label>
                    <select
                      id="branchSelect"
                      className="form-control"
                      value={selectedBranch}
                      onChange={(e) => setSelectedBranch(e.target.value)}
                    >
                      <option value="">Choose a branch...</option>
                      {branches.map((branch) => (
                        <option key={branch.branch_id} value={branch.branch_name}>
                          {branch.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  {filteredAccounts.map((item) => (
                    <div className="col-md-12" key={item.sales_shifts_id}>
                      <div className="card-container">
                        <div className="row">
                          <div className="col-xl-3 col-lg-3 col-md-3 col-xs-12 col-xm-12">
                            <div className="inner-card-container">
                              <div>{item.sales_shifts_id}</div>
                              <div style={{ fontSize: 13, textAlign: "center", fontWeight: "bold", color: "blue" }}>
                                <strong>{item.branch}</strong>
                                <br /></div><div>
                                {item.operator}
                                <br />
                                Shift Closed <br /> {item.shift_close_date} {item.shift_close_time || 'N/A'}
                                <br />
                                Shift Opened <br /> {item.shift_open_date} {item.shift_open_time || 'N/A'}
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-3 col-lg-3 col-md-3 col-xs-12 col-xm-12">
                            <div className="inner-card-container">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ textAlign: "left", fontWeight: "bold", color: "blue", fontSize: 13 }}>
                                  Customers
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right", fontWeight: "bold", color: "blue", fontSize: 13 }}>
                                  {item.total_transactions}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 11, textAlign: "left" }}>
                                  Uncollected Closed
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right" }}>
                                  {item.bd_uncollected_inventory} KGS
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 11, textAlign: "left" }}>
                                  Uncollected Mvt
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right" }}>
                                  {item.collected_net_movement} KGS
                                </div>
                              </div>
                            </div>
                            <div className="inner-card-container">
                              <div className="row">
                                <div className="col-xl-5 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ textAlign: "left", fontWeight: "bold", color: "blue", fontSize: 13 }}>
                                  Sold
                                </div>
                                <div className="col-xl-7 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right", fontWeight: "bold", color: "blue", fontSize: 13 }}>
                                  {item.sold_inventory} KGS
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 11, textAlign: "left" }}>
                                  Open
                                </div>
                                <div className="col-xl-7 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right" }}>
                                  {item.opening_inventory} KGS
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-xl-5 col-lg-6 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 11, textAlign: "left" }}>
                                  Closing
                                </div>
                                <div className="col-xl-7 col-lg-6 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "right" }}>
                                  {item.closing_inventory} KGS
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div className="col-xl-3 col-lg-3 col-md-3 col-xs-3 col-xm-3">
                            <div className="inner-card-container">
                            <div style={{ fontSize: 13, textAlign: "center", fontWeight: "bold", color: "blue" }}>
                              Collected Cash and Petty Cash<br></br></div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-6 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZIG
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.pettycash_cas}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ECO
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.pettycash_eco}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZPT
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.pettycash_zpt}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 13, textAlign: "right", fontWeight: "bold", color: "blue" }}>
                                  USD
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ fontSize: 13, textAlign: "left", fontWeight: "bold", color: "blue" }}>
                                  $ {item.pettycash_usd}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZAR
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ fontSize: 10, textAlign: "left" }}>
                                  R {item.pettycash_zar}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-3 col-lg-3 col-md-3 col-xs-3 col-xm-3">
                            <div className="inner-card-container">
                            <div style={{ fontSize: 13, textAlign: "center", fontWeight: "bold", color: "blue" }}>
                              Closing Cash At Site<br></br></div>
                              <div className="row">
                              
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-6 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZIG
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.tendered_cas}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ECO
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.tendered_eco}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZPT
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ textAlign: "left" }}>
                                  $ {item.tendered_zpt}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 13, textAlign: "right", fontWeight: "bold", color: "blue" }}>
                                  USD
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ fontSize: 13, textAlign: "left", fontWeight: "bold", color: "blue" }}>
                                  $ {item.tendered_usd}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-xs-5 col-xm-5" style={{ fontSize: 10, textAlign: "right" }}>
                                  ZAR
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-xs-7 col-xm-7" style={{ fontSize: 10, textAlign: "left" }}>
                                  R {item.tendered_zar}
                                </div>
                              </div>
                            </div>
                          </div>





                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ width: "100%", float: "right" }}>
              <Footer />
            </div>
          </div>
          
          <style>
            {`
              .card-container {
                background-color: white;
                border: 1px solid #ccc; /* Grey outline */
                border-radius: 8px; /* Rounded corners */
                padding: 15px;
                margin-bottom: 15px; /* Space between cards */
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */
              }
              .inner-card-container {
                background-color: rgb(248, 232, 248); /* Light grey background */
                border: 1px solid #ccc; /* Grey outline */
                border-radius: 6px; /* Rounded corners */
                padding: 10px;
              }
              h5 {
                margin-bottom: 10px; /* Space below section headers */
              }
            `}
          </style>

          <script src="../assets/vendor/jquery/jquery-3.3.1.min.js"></script>
          <script src="../assets/vendor/bootstrap/js/bootstrap.bundle.js"></script>
          <script src="../assets/vendor/slimscroll/jquery.slimscroll.js"></script>
          <script src="../assets/libs/js/main-js.js"></script>
        
    
          </div> </div> </div>
  );
};

export default SalesShift;